import { render, staticRenderFns } from "./dataform.vue?vue&type=template&id=ccfcffb4&scoped=true&"
import script from "./dataform.vue?vue&type=script&lang=js&"
export * from "./dataform.vue?vue&type=script&lang=js&"
import style0 from "./dataform.vue?vue&type=style&index=0&id=ccfcffb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfcffb4",
  null
  
)

export default component.exports